import React from "react";
import menuItems from "config/menuItems";
import { useHistory } from "react-router-dom";
import Flip from "react-reveal/Flip";
// Comps
// Css
import classes from "./Menu.module.scss";

const Menu: React.FC = () => {
  const history = useHistory();

  const handleRoute = (route) => {
    history.push(route);
  };

  return (
    <div className={classes.container}>
      <Flip bottom cascade>
        <div className={classes.wrapper}>
          {menuItems.map((item, index) => (
            <h1
              key={index}
              className={classes.item}
              onClick={() => handleRoute(item.route)}
            >
              {item.label}
            </h1>
          ))}
        </div>
      </Flip>
    </div>
  );
};

export default Menu;
